<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <el-row>
      <el-col :span="3" class="item-label"><span class="hl-red">保费</span></el-col>
      <el-col :span="3">
        <el-input v-model="input_premium" placeholder="请输入保费" @input="inputPremium" class="w-100" ></el-input>
      </el-col>
      <el-col :span="18" class="item-label">
        <el-button type="primary" size="mini" @click="addServiceContent">增加产品</el-button>
        <el-button type="primary" size="mini" @click="saveData">保存</el-button></el-col>
    </el-row>

    <el-row>
      <el-col :span="3" class="item-label"><span class="hl-red">险种</span></el-col>
      <el-col :span="21">
        <el-cascader placeholder="保险公司 / 所属分公司 / 险种 / 手续费比例 / 佣金比例"
                     v-model="settingValue"
                     :options="settingOptions"
                     @change="handleSettingChange" class="w-100"></el-cascader>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="21" :offset="3">
        <el-checkbox v-model="input_is_equal_premium">以相等保费计算</el-checkbox>
        <el-checkbox v-model="input_is_equal_commission_rate">以相等手续费比例计算</el-checkbox>
      </el-col>
    </el-row>
    <el-divider></el-divider>

    <el-row>
      <el-col :span="2" class="item-label">保单号</el-col>
      <el-col :span="6">
        <el-input v-model="input_policy_number"  @input="inputPolicyNumber" placeholder="请输入" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">保费占比</el-col>
      <el-col :span="2">
        <el-input-number controls-position="right" :min="0" :max="1" :step="0.01" v-model="input_premium_percentage" @input="inputPercentage" class="w-100"></el-input-number>
      </el-col>
    </el-row>

    <el-row>
      <!--
      <el-col :span="2" class="item-label">保费占比</el-col>
      <el-col :span="2">
        <el-input-number controls-position="right" :min="0" :max="1" :step="0.01" v-model="input_premium_percentage" @input="inputPercentage" class="w-100"></el-input-number>
      </el-col>
      -->
      <el-col :span="2" class="item-label">保费</el-col>
      <el-col :span="2">
        <el-input :disabled="false" v-model="c_premium" @input="inputPremium" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">手续费比例</el-col>
      <el-col :span="2">
        <el-input v-model="input_commission_rate"  @input="inputCommissionRate" placeholder="请输入" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">手续费税率</el-col>
      <el-col :span="2">
        <el-input v-model="input_vat_rate" @input="inputVatRate" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">开票比例</el-col>
      <el-col :span="2">
        <el-input v-model="input_invoice_rate" placeholder="请输入"
                  @input="inputInvoiceRate" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">不开票比例</el-col>
      <el-col :span="2">
        <el-input v-model="input_un_invoice_rate" placeholder="请输入"
                  @input="inputUnInvoiceRate"  class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">佣金比例</el-col>
      <el-col :span="2">
        <el-input v-model="input_commission_2agent_rate" @input="inputCommission2AgentRate" placeholder="请输入佣金支出比例" class="w-100"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="2" class="item-label">公司收入</el-col>
      <el-col :span="2">
        <el-input v-model="input_commission_2yihe" :disabled="true"
                  @input="inputCommission2Yihe" placeholder="请输入乙禾手续费" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">手续费收入</el-col>
      <el-col :span="2">
        <el-input v-model="input_commission" :disabled="true"
                  @input="inputCommission" placeholder="请输入" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">税金</el-col>
      <el-col :span="2">
        <el-input v-model="input_vat" :disabled="true"
                  @input="inputVat" placeholder="请输入扣减税金" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">开票金额</el-col>
      <el-col :span="2">
        <el-input v-model="input_invoice" :disabled="true" placeholder="请输入开票金额"
                  @input="inputInvoice"  class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">不开票金额</el-col>
      <el-col :span="2">
        <el-input v-model="input_un_invoice" :disabled="true" placeholder="请输入不开票金额"
                  @input="inputUnInvoice" class="w-100"></el-input>
      </el-col>

      <el-col :span="2" class="item-label">佣金支出</el-col>
      <el-col :span="2">
        <el-input v-model="input_commission_2agent" :disabled="true" placeholder="请输入佣金支出"
                  @input="inputCommission2Agent" class="w-100"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <table v-for="(service, i) in service_contents" :key="i" class="service_table" @click="setActivity(i)">
        <tr>
          <td class="service_table_title p25">保险公司</td>
          <td class="service_table_title ">险种</td>
          <td class="service_table_title p9">保费</td>
          <td class="service_table_title p9">手续费比例</td>
          <td class="service_table_title p9">手续费税率</td>
          <td class="service_table_title p9">开票比例</td>
          <td class="service_table_title p9">不开票比例</td>
          <td class="service_table_title p9">佣金比例</td>
          <td class="service_table_title p8">操作</td>
        </tr>
        <tr :class="service.content_style">
          <td class="service_table_field">{{service.insurance_company}}</td>
          <td class="service_table_field">{{service.insurance_type}}</td>
          <td class="service_table_field">{{service.premium}}</td>
          <td class="service_table_field">{{service.commission_rate}}</td>
          <td class="service_table_field">{{service.vat_rate}}</td>
          <td class="service_table_field">{{service.invoice_rate}}</td>
          <td class="service_table_field">{{service.un_invoice_rate}}</td>
          <td class="service_table_field">{{service.commission_2agent_rate}}</td>
          <td class="service_table_field" rowspan="3">
            <el-button type="text" size="mini" @click.stop="getServiceContent(i)" :disabled="service.is_reconciled === 1">修改</el-button><br/>
            <el-button type="text" size="mini" @click.stop="deleteServiceContent(i)" :disabled="service.is_reconciled === 1">删除</el-button><br/>
            <el-button type="text" size="mini" @click.stop="updateServiceContent(i)" :disabled="service.is_reconciled === 1">设置</el-button><br/>
            <el-button type="text" size="mini" @click.stop="setAsMaster(i)">设为主服务</el-button>
          </td>
        </tr>
        <tr>
          <td class="service_table_title_sec">保险公司所属分公司</td>
          <td class="service_table_title_sec">保单号</td>
          <td class="service_table_title_sec">公司收入</td>
          <td class="service_table_title_sec">手续费</td>
          <td class="service_table_title_sec">税金</td>
          <td class="service_table_title_sec">开票金额</td>
          <td class="service_table_title_sec">不开票金额</td>
          <td class="service_table_title_sec">佣金支出</td>
        </tr>
        <tr :class="service.content_style">
          <td class="service_table_field">{{service.insurance_company_branch_office}}</td>
          <td class="service_table_field">{{service.policy_number}}</td>
          <td class="service_table_field">{{service.commission_2yihe}}</td>
          <td class="service_table_field">{{service.commission}}</td>
          <td class="service_table_field">{{service.vat}}</td>
          <td class="service_table_field">{{service.invoice}}</td>
          <td class="service_table_field">{{service.un_invoice}}</td>
          <td class="service_table_field">{{service.commission_2agent}}</td>
        </tr>
      </table>
    </el-row>

    <!-- 汇总表格   -->
    <el-divider></el-divider>
    <el-row>
      <table class="summary_table" >
        <tr>
          <td class="summary_title p25">保险公司</td>
          <td class="summary_title ">险种</td>
          <td class="summary_title p9">保费</td>
          <td class="summary_title p9">手续费比例</td>
          <td class="summary_title p9">手续费税率</td>
          <td class="summary_title p9">开票比例</td>
          <td class="summary_title p9">不开票比例</td>
          <td class="summary_title p9">佣金比例</td>
          <td class="summary_title p8"></td>
        </tr>
        <tr>
          <td class="summary_field">{{fin_info.insurance_company}}</td>
          <td class="summary_field" rowspan="3">{{fin_info.insurance_type}}</td>
          <td class="summary_field">{{fin_info.premium}}</td>
          <td class="summary_field">{{fin_info.commission_rate}}</td>
          <td class="summary_field">{{fin_info.vat_rate}}</td>
          <td class="summary_field">{{fin_info.invoice_rate}}</td>
          <td class="summary_field">{{fin_info.un_invoice_rate}}</td>
          <td class="summary_field">{{fin_info.commission_2agent_rate}}</td>
          <td class="summary_field" rowspan="3"></td>
        </tr>
        <tr>
          <td class="summary_title">保险公司所属分公司</td>
          <td class="summary_title">公司收入</td>
          <td class="summary_title">手续费</td>
          <td class="summary_title">税金</td>
          <td class="summary_title">开票金额</td>
          <td class="summary_title">不开票金额</td>
          <td class="summary_title">佣金支出</td>
        </tr>
        <tr >
          <td class="summary_field">{{fin_info.insurance_company_branch_office}}</td>
          <td class="summary_field">{{fin_info.commission_2yihe}}</td>
          <td class="summary_field">{{fin_info.commission}}</td>
          <td class="summary_field">{{fin_info.vat}}</td>
          <td class="summary_field">{{fin_info.invoice}}</td>
          <td class="summary_field">{{fin_info.un_invoice}}</td>
          <td class="summary_field">{{fin_info.commission_2agent}}</td>
        </tr>
      </table>
    </el-row>
  </el-dialog>
</template>

<script>
import { fetchSettingAll } from '@/api/billing'
export default {
  name: 'service-info-input',
  props: {
    policy_number:{ default: ''},
    is_disabled: { default: true },
    insurance_company:{ default:'' },
    insurance_company_branch_office:{ default:'' },
    insurance_type:{default:''},
    commission_rate:{default:0},
    commission_2agent_rate:{default:0},
    premium:{default:0},
    vat_rate:{default:1},
    commission:{default:0},
    commission_2agent:{default:0},
    vat:{default:0},
    commission_2yihe:{default:0},
    invoice_rate:{default:0},
    un_invoice_rate:{default:0},
    invoice:{default:0},
    un_invoice:{default:0},
    services:{default: function() {return []}},
    is_equal_premium: {default:0},
    is_equal_commission_rate: {default:0},
  },
  data() {
    return {
      disabled: this.is_disabled,
      dialogVisible: false,
      // 保险公司,险种,手续费比例,佣金比例选项
      settingOptions:[],
      settingValue: [],

      selected_idx: null,
      fin_info: {
        policy_number: this.policy_number,
        insurance_company: this.insurance_company,
        insurance_company_branch_office: this.insurance_company_branch_office,
        insurance_type: this.insurance_type,
        commission_rate: this.commission_rate,
        commission_2agent_rate: this.commission_2agent_rate,
        vat_rate: this.vat_rate,
        premium: this.premium,
        commission: this.commission,
        commission_2agent: this.commission_2agent,
        vat: this.vat,
        commission_2yihe: this.commission_2yihe,
        invoice_rate: this.invoice_rate,
        un_invoice_rate: this.un_invoice_rate,
        invoice: this.invoice,
        un_invoice: this.un_invoice,
        services: {},
        is_equal_premium: 0,
        is_equal_commission_rate: 0,
      },
      input_policy_number: '',
      input_insurance_company: '',
      input_insurance_company_branch_office: '',
      input_insurance_type: '',
      input_premium_percentage: 1.0,
      input_commission_rate: 0,
      input_commission_2agent_rate: 0,
      input_vat_rate: 1,
      input_premium: this.premium,
      input_commission: 0,
      input_commission_2agent: 0,
      input_vat: 0,
      input_commission_2yihe: 0,
      input_invoice_rate: 0,
      input_un_invoice_rate: 0,
      input_invoice: 0,
      input_un_invoice: 0,
      input_content_style: '',

      service_contents:[],
      input_is_equal_premium: this.is_equal_premium,
      input_is_equal_commission_rate: this.is_equal_commission_rate,
      // idx: null,
    }
  },
  watch: {
    'is_disabled': function (val){
      this.disabled = val
    },
    // 'is_group_insurance': function (val){
    //   this.fin_info.is_group_insurance = val
    // },
    'policy_number': function(val){
      this.fin_info.policy_number = val
      if (Array.isArray(this.service_contents)){
        this.service_contents.forEach((item, i)=>{
          item.policy_number = val
        })
      }

    },
    'insurance_company': function(val){
      this.fin_info.insurance_company = val
    },
    'insurance_company_branch_office': function(val){
      this.fin_info.insurance_company_branch_office = val
    },
    'insurance_type': function(val){
      this.fin_info.insurance_type = val
    },
    'commission_rate': function(val){
      this.fin_info.commission_rate = val
    },
    'commission_2agent_rate': function(val){
      this.fin_info.commission_2agent_rate = val
    },
    'vat_rate': function(val){
      this.fin_info.vat_rate = val
    },
    'premium': function(val){
      this.fin_info.premium = val
      this.input_premium = val
    },
    'commission': function(val){
      this.fin_info.commission = val
    },
    'commission_2agent': function(val){
      this.fin_info.commission_2agent = val
    },
    'vat': function(val){
      this.fin_info.vat = val
    },
    'commission_2yihe': function(val){
      this.fin_info.commission_2yihe = val
    },
    'invoice_rate': function(val){
      this.fin_info.invoice_rate = val
    },
    'un_invoice_rate': function(val){
      this.fin_info.un_invoice_rate = val
    },
    'invoice': function(val){
      this.fin_info.invoice = val
    },
    'un_invoice': function(val){
      this.fin_info.un_invoice = val
    },
    'services': function(val){
      this.service_contents = val
    },
  },
  computed: {
    c_premium: {
      get: function() {
        return (this.input_premium * this.input_premium_percentage).toFixed(2)
      },
      set: function(val) {
        console.log('修改c_premium值：', val)
        this.input_premium_percentage = val / this.input_premium
      }
    }
  },
  created() {
    this.loadData()
  },
  methods:{
    loadData(){
      let p = []
      p.push(fetchSettingAll())
      Promise.all(p)
          .then(res => {
            // 获取费率设置选项
            this.settingOptions= res[0]
          })
          .catch(error => {
            this.$message.error(error)
          })
    },
    showDialog(){
      this.dialogVisible = true
    },

    // 选项变更操作
    handleSettingChange(value) {
      // this.changeIsGroupInsurance(value)
      if(value[0] !== null && value[0] !== undefined){
        this.input_insurance_company = value[0]
      }
      if(value[1] !== null && value[1] !== undefined){
        this.input_insurance_company_branch_office = value[1]
      }
      if(value[2] !== null && value[2] !== undefined){
        this.input_insurance_type = value[2]
      }
      if(value[3] !== null && value[3] !== undefined){
        this.input_commission_rate = value[3]
      }
      if(value[4] !== null && value[4] !== undefined){
        this.input_commission_2agent_rate = value[4]
      }
      this.flushInput()
      this.updateFinInfo()
    },

    // 服务增、删、改
    addServiceContent(){
      let service_content = {
        id:null,
        policy_number: this.input_policy_number,
        insurance_company: this.input_insurance_company,
        insurance_company_branch_office: this.input_insurance_company_branch_office,
        insurance_type: this.input_insurance_type,
        premium_percentage: this.input_premium_percentage,
        commission_rate: this.input_commission_rate,
        commission_2agent_rate: this.input_commission_2agent_rate,
        vat_rate: this.input_vat_rate,
        premium: this.c_premium,
        commission: this.input_commission,
        commission_2agent: this.input_commission_2agent,
        vat: this.input_vat,
        commission_2yihe: this.input_commission_2yihe,
        invoice_rate: this.input_invoice_rate,
        un_invoice_rate: this.input_un_invoice_rate,
        invoice: this.input_invoice,
        un_invoice: this.input_un_invoice,
        content_style: this.input_content_style
      }
      this.service_contents.push(service_content)
      const idx = this.service_contents.length - 1
      this.setActivity(idx)
      this.updateFinInfo()
    },
    deleteServiceContent(idx){
      this.service_contents.splice(idx,1)
      if (this.service_contents.length > 0) {
        this.selected_idx = this.service_contents.length - 1
        this.setActivity(this.selected_idx)
      } else {
        this.selected_idx = null
      }
      this.updateFinInfo()
    },
    updateServiceContent(idx){
      this.setActivity(idx)
      this.setServiceContent()
      this.updateFinInfo()
    },
    getServiceContent(idx){
      this.setActivity(idx)
      let sc = this.service_contents[idx]
      console.log(sc)
      
      this.input_insurance_company = sc.insurance_company
      this.input_insurance_company_branch_office = sc.insurance_company_branch_office
      this.input_insurance_type = sc.insurance_type
      this.input_policy_number = sc.policy_number
      this.c_premium = sc.premium
      this.input_commission_rate = sc.commission_rate
      this.input_vat_rate = sc.vat_rate
      this.input_invoice_rate = sc.invoice_rate
      this.input_un_invoice_rate = sc.un_invoice_rate
      this.input_commission_2agent_rate = sc.commission_2agent_rate
      this.input_commission_2yihe = sc.commission_2yihe
      this.input_commission = sc.commission
      this.input_vat = sc.vat
      this.input_invoice = sc.invoice
      this.input_un_invoice = sc.un_invoice
      this.input_commission_2agent = sc.commission_2agent
    },


    // 服务操作
    setActivity(idx){
      this.selected_idx = idx
      this.service_contents.forEach((item, i) => {
        if(i === idx){
          item.content_style = 'active'
        } else {
          item.content_style = ''
        }
      })
    },
    setAsMaster(idx){
      this.setActivity(idx)
      this.selected_idx = idx
      this.service_contents.forEach((item, i) => {
        if(i === idx){
          this.fin_info.insurance_company = item.insurance_company
          this.fin_info.insurance_company_branch_office = item.insurance_company_branch_office
          this.fin_info.insurance_type = item.insurance_type
        }
      })
    },


    // 数据变更操作
    setServiceContent(){
      let idx = null
      if (this.service_contents.length > 0 && this.selected_idx !== null) {
        idx = this.selected_idx
      } else if (this.service_contents.length > 0 && this.selected_idx === null) {
        idx = 0
      }
      if (idx !== null){
        this.service_contents[idx].policy_number = this.input_policy_number
        this.service_contents[idx].insurance_company = this.input_insurance_company
        this.service_contents[idx].insurance_company_branch_office = this.input_insurance_company_branch_office
        this.service_contents[idx].insurance_type = this.input_insurance_type

        this.service_contents[idx].premium = this.c_premium
        this.service_contents[idx].commission_2yihe = this.input_commission_2yihe

        this.service_contents[idx].premium_percentage = this.input_premium_percentage

        this.service_contents[idx].commission_rate = this.input_commission_rate
        this.service_contents[idx].commission = this.input_commission

        this.service_contents[idx].vat_rate = this.input_vat_rate
        this.service_contents[idx].vat = this.input_vat

        this.service_contents[idx].invoice_rate = this.input_invoice_rate
        this.service_contents[idx].invoice = this.input_invoice

        this.service_contents[idx].un_invoice_rate = this.input_un_invoice_rate
        this.service_contents[idx].un_invoice = this.input_un_invoice

        this.service_contents[idx].commission_2agent_rate = this.input_commission_2agent_rate
        this.service_contents[idx].commission_2agent = this.input_commission_2agent
      }
    },
    resetFinInfo(){
      this.fin_info.insurance_company = ''
      this.fin_info.insurance_company_branch_office = ''
      this.fin_info.insurance_type = ''
      this.fin_info.commission_rate = 0
      this.fin_info.commission_2agent_rate = 0
      this.fin_info.vat_rate = 0
      this.fin_info.premium = 0
      this.fin_info.commission = 0
      this.fin_info.commission_2agent = 0
      this.fin_info.vat = 0
      this.fin_info.commission_2yihe = 0
      this.fin_info.invoice_rate = 0
      this.fin_info.un_invoice_rate = 0
      this.fin_info.invoice = 0
      this.fin_info.un_invoice = 0
      this.fin_info.services = this.service_contents
    },
    setFinInfo(){
      this.resetFinInfo()
      this.service_contents.forEach((item,i)=>{
        this.fin_info.insurance_company = item.insurance_company
        this.fin_info.insurance_company_branch_office = item.insurance_company_branch_office
        this.fin_info.insurance_type = item.insurance_type

        if (this.input_is_equal_premium===true){
          this.fin_info.premium = parseFloat(item.premium)
        } else {
          this.fin_info.premium += parseFloat(item.premium)
        }
        this.fin_info.commission_2yihe += parseFloat(item.commission_2yihe)

        if (this.input_is_equal_commission_rate===true){
          this.fin_info.commission_rate = parseFloat(item.commission_rate)
        } else {
          this.fin_info.commission_rate += parseFloat(item.commission_rate)
        }
        this.fin_info.commission += parseFloat(item.commission)

        this.fin_info.vat_rate += parseFloat(item.vat_rate)
        this.fin_info.vat += parseFloat(item.vat)

        this.fin_info.invoice_rate += parseFloat(item.invoice_rate)
        this.fin_info.invoice += parseFloat(item.invoice)

        this.fin_info.un_invoice_rate += parseFloat(item.un_invoice_rate)
        this.fin_info.un_invoice += parseFloat(item.un_invoice)

        this.fin_info.commission_2agent_rate += parseFloat(item.commission_2agent_rate)
        this.fin_info.commission_2agent += parseFloat(item.commission_2agent)
      })

      // 共保才需重新计算相关比例
      if (this.service_contents.length > 1) {
        this.fin_info.vat_rate = parseFloat((this.fin_info.vat_rate / this.service_contents.length).toFixed(4))
        this.fin_info.commission_rate = parseFloat((this.fin_info.commission * this.fin_info.vat_rate / this.fin_info.premium).toFixed(4))
        this.fin_info.invoice_rate = parseFloat((this.fin_info.invoice * this.fin_info.vat_rate / this.fin_info.premium).toFixed(4))
        this.fin_info.un_invoice_rate = parseFloat((this.fin_info.un_invoice * this.fin_info.vat_rate / this.fin_info.premium).toFixed(4))
        this.fin_info.commission_2agent_rate = parseFloat((this.fin_info.commission_2agent / this.fin_info.premium).toFixed(4))
      }
      else {
        this.fin_info.vat_rate = parseFloat(this.fin_info.vat_rate.toFixed(4))
        this.fin_info.commission_rate = parseFloat(this.fin_info.commission_rate.toFixed(4))
        this.fin_info.invoice_rate = parseFloat(this.fin_info.invoice_rate.toFixed(4))
        this.fin_info.un_invoice_rate = parseFloat(this.fin_info.un_invoice_rate.toFixed(4))
        this.fin_info.commission_2agent_rate = parseFloat(this.fin_info.commission_2agent_rate.toFixed(4))
      }

      this.fin_info.commission_2yihe = parseFloat(this.fin_info.commission_2yihe.toFixed(4))
      this.fin_info.commission = parseFloat(this.fin_info.commission.toFixed(4))
      this.fin_info.vat = parseFloat(this.fin_info.vat.toFixed(4))
      this.fin_info.invoice = parseFloat(this.fin_info.invoice.toFixed(4))
      this.fin_info.un_invoice = parseFloat(this.fin_info.un_invoice.toFixed(4))
      this.fin_info.commission_2agent = parseFloat(this.fin_info.commission_2agent.toFixed(4))
    },
    updateFinInfo() {
      this.setFinInfo()
    },
    saveData() {
      this.$emit('change', this.fin_info)
      this.dialogVisible = false
    },

    calcCommission(premium, commission_rate, commission_2agent_rate, vat_rate){
      let c_premium = parseFloat(premium) * this.input_premium_percentage
      let c_commission_rate = parseFloat(commission_rate)
      let c_commission_2agent_rate = parseFloat(commission_2agent_rate)
      let c_vat_rate = parseFloat(vat_rate)
      let c_commission = 0
      let c_vat = 0
      let c_commission_2agent = 0
      let c_commission_2yihe = 0

      // 手续费、税金扣减、佣金、乙禾手续费计算
      c_commission = ((c_premium * c_commission_rate)/ c_vat_rate).toFixed(4)
      c_vat = (c_commission  / 1.06 * 0.0672).toFixed(4)
      c_commission_2agent = (c_premium * c_commission_2agent_rate).toFixed(2)
      c_commission_2yihe = (c_commission - c_vat - c_commission_2agent).toFixed(4)

      return [c_commission, c_vat, c_commission_2agent, c_commission_2yihe]
    },

    // 计算开票信息
    calcInvoice(field, premium, commission, invoice, un_invoice, commission_rate, vat_rate, invoice_rate, un_invoice_rate){
      let c_premium =  parseFloat(premium) * this.input_premium_percentage
      let c_commission =  parseFloat(commission)
      let c_invoice =  parseFloat(invoice)
      let c_un_invoice =  parseFloat(un_invoice)

      let c_vat_rate =  parseFloat(vat_rate)
      let c_commission_rate =  parseFloat(commission_rate)
      let c_invoice_rate =  parseFloat(invoice_rate)
      let c_un_invoice_rate =  parseFloat(un_invoice_rate)

      if (field === 'invoice_rate') {
        if (c_invoice_rate < 0) {
          c_invoice_rate = 0
        }
        if (c_invoice_rate > c_commission_rate ) {
          c_invoice_rate = c_commission_rate
        }
        c_un_invoice_rate = c_commission_rate - c_invoice_rate
        c_invoice = (c_premium * c_invoice_rate)/ c_vat_rate
        // c_un_invoice = (c_premium * c_un_invoice_rate)/ c_vat_rate
        c_un_invoice = c_commission - c_invoice
        /*
        * 当开票比例发生变化
        * 1：检查开票比例 0 < 开票比例 <手续费比例
        * 2：不开票比例 = 手续费比例 - 开票比例
        * 3：开票金额 =（保费 * 开票比例）/ 税率比例
        * 4：不开票金额 = 手续费比例 - 开票金额
        * */

      } else if (field === 'un_invoice_rate') {
        if (c_un_invoice_rate < 0) {
          c_un_invoice_rate = 0
        }
        if (c_un_invoice_rate > c_commission_rate ) {
          c_un_invoice_rate = c_commission_rate
        }
        c_invoice_rate = c_commission_rate - c_un_invoice_rate
        // c_invoice = (c_premium * c_invoice_rate)/ c_vat_rate
        c_un_invoice = (c_premium * c_un_invoice_rate)/ c_vat_rate
        c_invoice = c_commission - c_un_invoice
        /*
        * 当开票比例发生变化
        * 1：检查不开票比例 0 < 开票比例 <手续费比例
        * 2：开票比例 = 手续费比例 - 不开票比例
        * 3：不开票金额 =（保费 * 不开票比例）/ 税率比例
        * 4：开票金额 = 手续费比例 - 不开票金额
        * */
      } else if (field === 'invoice') {
        if (c_invoice < 0) {
          c_invoice = 0
        }
        if (c_invoice > c_commission ) {
          c_invoice = c_commission
        }
        c_un_invoice = c_commission - c_invoice
        c_invoice_rate = c_invoice / c_premium
        c_un_invoice_rate = c_commission_rate - c_invoice_rate
        /*
        * 当开票金额发生变化
        * 1：检查开票金额 0 < 开票金额 < 手续费
        * 2：不开票金额 = 手续费 - 开票金额
        * 3：开票比例 = 开票金额 / 手续费金额
        * 4 不开票金额 = 手续费比例 - 开票比例
        * */

      } else if (field === 'un_invoice') {
        if (c_un_invoice < 0) {
          c_un_invoice = 0
        }
        if (c_un_invoice > c_commission ) {
          c_un_invoice = c_commission
        }
        c_invoice = c_commission - c_un_invoice
        c_un_invoice_rate = c_un_invoice / c_premium
        c_invoice_rate = c_commission_rate - c_un_invoice_rate
        /*
        * 当开票金额发生变化
        * 1：检查不开票金额 0 < 不开票金额 < 手续费
        * 2：开票金额 = 手续费 - 不开票金额
        * 3：不开票比例 = 不开票金额 / 手续费金额
        * 4 开票金额 = 手续费比例 - 不开票比例
        * */
      } else {
        // c_invoice = c_commission - c_un_invoice
        // c_invoice_rate = c_invoice / c_premium
        // c_un_invoice_rate = c_un_invoice / c_premium
        c_invoice_rate = c_commission_rate - c_un_invoice_rate
        c_invoice = (c_premium * c_invoice_rate)/ c_vat_rate
        c_un_invoice = (c_premium * c_un_invoice_rate)/ c_vat_rate
      }

      // console.log('c_un_invoice: ' + c_un_invoice)
      // console.log('c_commission: ' + c_commission)
      // console.log('c_invoice: ' + c_invoice)
      // console.log('c_invoice_rate: ' + c_invoice_rate)
      // console.log('c_un_invoice_rate: ' + c_un_invoice_rate)

      c_invoice_rate = parseFloat(String(c_invoice_rate)).toFixed(4)
      c_un_invoice_rate = parseFloat(String(c_un_invoice_rate)).toFixed(4)
      c_invoice = parseFloat(String(c_invoice)).toFixed(4)
      c_un_invoice = parseFloat(String(c_un_invoice)).toFixed(4)

      // console.log('c_un_invoice2: ' + c_un_invoice)
      // console.log('c_commission2: ' + c_commission)
      // console.log('c_invoice2: ' + c_invoice)
      // console.log('c_invoice_rate2: ' + c_invoice_rate)
      // console.log('c_un_invoice_rate2: ' + c_un_invoice_rate)
      return [c_invoice_rate, c_un_invoice_rate, c_invoice, c_un_invoice]
    },

    flushInput(field='un_invoice_rate') {
      let premium = 0
      if (! isNaN(parseFloat(this.input_premium))){
        premium = parseFloat(this.input_premium)
      }

      let commission_rate = 0
      if (! isNaN(parseFloat(this.input_commission_rate))){
        commission_rate = parseFloat(this.input_commission_rate)
      }

      let commission_2agent_rate = parseFloat(this.input_commission_2agent_rate)
      if (! isNaN(parseFloat(this.input_commission_2agent_rate))){
        commission_2agent_rate = parseFloat(this.input_commission_2agent_rate)
      }

      let vat_rate = parseFloat(this.input_vat_rate)
      if (! isNaN(parseFloat(this.input_vat_rate))){
        vat_rate = parseFloat(this.input_vat_rate)
      }

      let [commission, vat, commission_2agent, commission_2yihe] = this.calcCommission(
          premium, commission_rate, commission_2agent_rate, vat_rate)

      let input_invoice = 0
      if (! isNaN(parseFloat(this.input_invoice))){
        input_invoice = parseFloat(this.input_invoice)
      }

      let input_un_invoice = 0
      if (! isNaN(parseFloat(this.input_un_invoice))){
        input_un_invoice = parseFloat(this.input_un_invoice)
      }

      let input_invoice_rate = 0
      if (! isNaN(parseFloat(this.input_invoice_rate))){
        input_invoice_rate = parseFloat(this.input_invoice_rate)
      }

      let input_un_invoice_rate = 0
      if (! isNaN(parseFloat(this.input_un_invoice_rate))){
        input_un_invoice_rate = parseFloat(this.input_un_invoice_rate)
      }

      let [invoice_rate, un_invoice_rate, invoice, un_invoice] = this.calcInvoice(
          field, premium, commission, input_invoice, input_un_invoice,
          commission_rate, vat_rate, input_invoice_rate, input_un_invoice_rate)

      // console.log(premium)
      // console.log(commission)
      // console.log(input_invoice)
      // console.log(input_un_invoice)
      // console.log(commission_rate)
      // console.log(vat_rate)
      // console.log(input_invoice_rate)
      // console.log(input_un_invoice_rate)
      //
      // console.log(invoice_rate)
      // console.log(un_invoice_rate)
      // console.log(invoice)
      // console.log(un_invoice)

      if (field !== 'premium') {
        this.input_premium = premium
      }

      if (field !== 'commission_rate') {
        this.input_commission_rate = commission_rate
      }

      if (field !== 'commission_2agent_rate') {
        this.input_commission_2agent_rate = commission_2agent_rate
      }

      if (field !== 'vat_rate') {
        this.input_vat_rate = vat_rate
      }

      if (field !== 'commission') {
        this.input_commission = commission
      }

      if (field !== 'vat') {
        this.input_vat = vat
      }

      if (field !== 'commission_2agent') {
        this.input_commission_2agent = commission_2agent
      }

      if (field !== 'commission_2yihe') {
        this.input_commission_2yihe = commission_2yihe
      }

      if (field !== 'invoice_rate') {
        this.input_invoice_rate = invoice_rate
      }

      if (field !== 'un_invoice_rate') {
        this.input_un_invoice_rate = un_invoice_rate
      }

      if (field !== 'invoice') {
        this.input_invoice = invoice
      }

      if (field !== 'un_invoice') {
        this.input_un_invoice = un_invoice
      }
    },

    // 数据返回操作
    inputInsuranceCompany(val){
      this.fin_info.insurance_company = val
      this.updateFinInfo()
    },
    inputInsuranceCompanyBranchOffice(val){
      this.fin_info.insurance_company_branch_office = val
      this.updateFinInfo()
    },
    inputInsuranceType(val){
      this.fin_info.insurance_type = val
      this.updateFinInfo()
    },
    inputPolicyNumber(val){
      this.flushInput('input_policy_number')
      this.updateFinInfo()
    },
    inputPercentage(val){
      this.flushInput('input_premium_percentage')
      this.updateFinInfo()
    },
    inputCommissionRate(val){
      this.flushInput('commission_rate')
      this.updateFinInfo()
    },
    inputCommission2AgentRate(val){
      this.flushInput('commission_2agent_rate')
      this.updateFinInfo()
    },
    inputPremium(val){
      this.flushInput('premium')
      this.updateFinInfo()
    },
    inputVatRate(val){
      this.flushInput('vat_rate')
      this.updateFinInfo()
    },
    inputCommission(val){
      this.flushInput('commission')
      this.updateFinInfo()
    },
    inputCommission2Agent(val){
      this.flushInput('commission_2agent')
      this.updateFinInfo()
    },
    inputVat(val){
      this.flushInput('vat')
      this.updateFinInfo()
    },
    inputCommission2Yihe(val){
      this.flushInput('commission_2yihe')
      this.updateFinInfo()
    },
    inputInvoiceRate(val){
      this.flushInput('invoice_rate')
      this.updateFinInfo()
    },
    inputUnInvoiceRate(val){
      this.flushInput('un_invoice_rate')
      this.updateFinInfo()
    },
    inputInvoice(val){
      this.flushInput('invoice')
      this.updateFinInfo()
    },
    inputUnInvoice(val){
      this.flushInput('un_invoice')
      this.updateFinInfo()
    },

    // 数据交验操作
    validate(){
      let result = []
      if(this.fin_info.insurance_company === '' || this.fin_info.insurance_company === null) result.push('经办保险公司')
      if(this.fin_info.insurance_company_branch_office === '' || this.fin_info.insurance_company === null) result.push('所属分公司')
      if(this.fin_info.insurance_type === '' || this.fin_info.insurance_company === null ) result.push('险种')
      if(this.fin_info.commission_rate === '' || this.fin_info.commission_rate === null || this.fin_info.commission_rate === 0) result.push('手续费比例')
      if(this.fin_info.commission_2agent_rate === '' || this.fin_info.commission_2agent_rate === null || this.fin_info.commission_2agent_rate === 0) result.push('佣金支出比例')
      if(this.fin_info.premium === '' || this.fin_info.premium === null || this.fin_info.premium === 0) result.push('保费')
      return result
    }
  }
}
</script>

<style scoped>
.service_table {
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
}
.service_table_title {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  background-color: #19aa8d;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
}
.service_table_title_sec {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  background-color: #86e0c5;
  vertical-align: center;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
}
.service_table_field {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  vertical-align: center;
  text-align: center;
}

.summary_table {
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
}
.summary_title {
  border: 1px solid #1d1d1d;
  text-align: center;
  font-weight: bold;
  background-color: #1d1d1d;
  color: #f9fafc;
}
.summary_field {
  border: 1px solid #1d1d1d;
  vertical-align: center;
  text-align: center;
}

.item-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hl-red {
  color: red;
}
.active {
  background-color: #444141;
  color: #FFFFFF;
}
>>> .el-radio-group{
  margin: 10px;
}
>>> .el-dialog {
  width:96%
}

.p25{
  width: 25%;
}
.p10{
  width: 10%;
}
.p9{
  width: 9%;
}
.p8{
  width: 8%;
}
</style>
